// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"ccb6f5e3","104":"a9b74fba","144":"51c36a63","254":"668647a0","323":"982776c1","376":"1723c93a","390":"fd664740","503":"82497fbe","562":"f2e3cefc","585":"a00ea400","760":"d7cf10a7","808":"901bfdee","823":"e16eacfe","956":"1a208be8"}[chunkId] + ".chunk.js";
};